export function cloneConfigObject<T>(value: T): T {
  if (typeof structuredClone === "function") {
    return structuredClone(value);
  }
  return JSON.parse(JSON.stringify(value)) as T;
}

export function serializeConfigForm(form: Record<string, 未知>): string {
  return `${JSON.stringify(form, null, 2).trimEnd()}\n`;
}

export function setPathValue(
  obj: Record<string, 未知> | 未知[],
  path: Array<string | number>,
  value: 未知,
) {
  if (path.length === 0) return;
  let current: Record<string, 未知> | 未知[] = obj;
  for (let i = 0; i < path.length - 1; i += 1) {
    const key = path[i];
    const nextKey = path[i + 1];
    if (typeof key === "number") {
      if (!Array.isArray(current)) return;
      if (current[key] == null) {
        current[key] =
          typeof nextKey === "number" ? [] : ({} as Record<string, 未知>);
      }
      current = current[key] as Record<string, 未知> | 未知[];
    } else {
      if (typeof current !== "object" || current == null) return;
      const record = current as Record<string, 未知>;
      if (record[key] == null) {
        record[key] =
          typeof nextKey === "number" ? [] : ({} as Record<string, 未知>);
      }
      current = record[key] as Record<string, 未知> | 未知[];
    }
  }
  const lastKey = path[path.length - 1];
  if (typeof lastKey === "number") {
    if (Array.isArray(current)) current[lastKey] = value;
    return;
  }
  if (typeof current === "object" && current != null) {
    (current as Record<string, 未知>)[lastKey] = value;
  }
}

export function removePathValue(
  obj: Record<string, 未知> | 未知[],
  path: Array<string | number>,
) {
  if (path.length === 0) return;
  let current: Record<string, 未知> | 未知[] = obj;
  for (let i = 0; i < path.length - 1; i += 1) {
    const key = path[i];
    if (typeof key === "number") {
      if (!Array.isArray(current)) return;
      current = current[key] as Record<string, 未知> | 未知[];
    } else {
      if (typeof current !== "object" || current == null) return;
      current = (current as Record<string, 未知>)[key] as
        | Record<string, 未知>
        | 未知[];
    }
    if (current == null) return;
  }
  const lastKey = path[path.length - 1];
  if (typeof lastKey === "number") {
    if (Array.isArray(current)) current.splice(lastKey, 1);
    return;
  }
  if (typeof current === "object" && current != null) {
    delete (current as Record<string, 未知>)[lastKey];
  }
}
